import MainLayout from "components/layout/main-layout/MainLayout";
import "./SubscriberProfile.css";
import { titles } from "constants/titles";
import { ArrowRight, EmergencyIcon, ShippingIcon, SignalHistoryIcon } from "assets/SVGs/SVGs";
import CustomButton from "components/widgets/custom-button/CustomButton";
import { ROUTES_CONSTANTS } from "routes/route-constants";
import { useHistory } from "react-router-dom";
import { useEffect, useState } from "react";
import InformationModal from "components/layout/information-modal/InformationModal";
import { useDispatch, useSelector } from "react-redux";
import {
  getLanguages,
  getPhoneTypeList,
  getRegionList,
} from "redux/Common/action";
import { getEmergencyData, getRelationList } from "redux/EmergencyPlan/actions";
import {
  getCancelSubscriptionList,
  getMedicalAlertUserDetail,
} from "redux/MedicalAlertUsers/actions";
import { getDeviceList, getDeviceSignalHistory } from "redux/Devices/actions";
import {
  getBankAccountTypes,
  getBillingBankDetail,
  getBillingCardDetail,
  getCardList,
} from "redux/Payments/actions";
import {
  convertInRequiredTimeZone,
  formatPhoneNumber,
  getSubscriberProtectedAddress,
} from "utility";
import SubscriberInformationCard from "components/layout/subscriber-information-card/SubscriberInformationCard";
import DeviceTrackingCard from "components/layout/device-tracking-card/DeviceTrackingCard";
import SubscriberDetailsCard from "components/layout/subscriber-details-card/SubscriberDetailsCard";
import BillingDetailsCard from "components/layout/billing-details-card/BillingDetailsCard";

const SubscriberProfile = () => {
  const [showEmergencyInfoModal, setShowEmergencyInfoModal] = useState(false);
  const [emergencyContactList, setEmergencyContactList] = useState([]);
  const [snackBarMessage, setSnackBarMessage] = useState({
    message: "",
    type: "",
  });
  const userData = useSelector((store) => store?.auth?.userData);
  const { emergencyData, relationList } = useSelector(
    (store) => store?.emergencyData
  );
  const { loading, medicalUserDetail, selectedMedicalUser, cancelSubscriptionList } = useSelector(
    (store) => store?.medicalAlertUsers
  );
  const { deviceSignalHistory } = useSelector((store) => store?.devices);
  const { cardDetails, cardList, bankDetails, accountTypes } = useSelector(
    (store) => store?.payments
  );
  const {
    phoneTypeList = [],
    languageList,
    currentTimeZone,
  } = useSelector((store) => store?.common);
  const allRegionList = useSelector((store) => store?.common?.allRegionList);

  const dispatch = useDispatch();
  const history = useHistory();

  const accordianButtons = [
    {
      name: titles?.invoices_bills,
      onClick: () =>
        history.push(ROUTES_CONSTANTS?.invoicesAndBills, {
          medicalUserDetail: medicalUserDetail,
          cardList: cardList,
        }),
    },
    {
      name: titles?.sales_orders_subscriptions,
      onClick: () => history.push(ROUTES_CONSTANTS?.orderHistory),
    },

    //hide as per client requirement
    // {
    //   name: !cancelSubscriptionList?.is_subscription_active || medicalUserDetail?.is_subscription_cancelled ? titles?.renewSubscription : titles?.cancel_services,
    //   onClick: () => handleNavigation()
    // },
  ];

  const handleNavigation = () => {
    if (!cancelSubscriptionList?.is_subscription_active || medicalUserDetail?.is_subscription_cancelled) {
      //navigate to renew
      history.push(ROUTES_CONSTANTS?.renewSubscription, {
        medicalUserData: selectedMedicalUser,
      })
    } else {
      if (cancelSubscriptionList?.data?.length > 0 && (!cancelSubscriptionList?.is_subscription_active || cancelSubscriptionList?.is_subscription_active)) {
        //navigate to list
        history.push(ROUTES_CONSTANTS?.subscriptionList, {
          medicalUserData: selectedMedicalUser,
        })
      } else {
        history.push(ROUTES_CONSTANTS?.cancelServices, {
          medicalUserData: selectedMedicalUser,
        })
      }
    }
  }



  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    initialStates();
  }, [emergencyData?.emergency_contacts]);

  const getData = () => {
    const param = {
      dispatch,
      history,
      userType: userData?.isGuestUser ? "guestuser" : "accountowner",
      emergency_contract_id: selectedMedicalUser?.service_contract_id,
      medical_alert_user_id: selectedMedicalUser?.medical_alert_user_id,
      user_device_id: undefined,
      setSnackBarMessage,
      is_visible: false,
    };
    getEmergencyData(param);
    getLanguages(param);
    getRelationList(param);
    getPhoneTypeList(param);
    getMedicalAlertUserDetail(param);
    getDeviceList(param);
    getDeviceSignalHistory(param);
    getBankAccountTypes(param);
    getSuscriberList();
    if (!userData?.isGuestUser) {
      getBillingCardDetail(param);
      getBillingBankDetail(param);
      getCardList(param);
    }
  };

  const getSuscriberList = () => {
    const params = {
      dispatch,
      payload: {
        medical_alert_user_id: selectedMedicalUser?.medical_alert_user_id,
      },
      userType: userData?.isGuestUser ? "guestuser" : "accountowner",
      history,
    };
    getCancelSubscriptionList(params);
  }

  const initialStates = () => {
    let list = emergencyData?.emergency_contacts || [];
    let formattedList = [];
    list?.forEach((item, index) => {
      const relation = relationList?.filter(
        (obj) => obj?.relation_id === item?.relation_to_user
      );
      const selectedPhoneType = phoneTypeList?.filter(
        (obj) => obj?.phone_type_id === item?.primary_phone_type
      );
      const relationName =
        relation && relation?.length > 0 ? relation[0]?.relation : "";
      const name = item?.first_name + " " + item?.last_name;
      let obj = {
        dragKey: name + index,
        key: index,
        relation: relation && relation?.length > 0 ? relation[0] : undefined,
        phone: item?.primary_number,
        name: name,
        phoneNumber: `${name}, ${relationName}\n${item?.primary_number}`,
        primary_phone_type:
          selectedPhoneType && selectedPhoneType?.length > 0
            ? selectedPhoneType[0]
            : undefined,
        otherData: item,
        is_delete: false,
      };
      formattedList.push(obj);
    });
    let newList = [];
    formattedList?.forEach((item) => {
      const isBefore = item?.otherData?.call_before_911;
      if (isBefore) {
        newList?.push(item);
      }
    });
    newList.push({
      is_delete: false,
      key: 10,
      dragKey: 10,
      name: "Default",
      phone: "(123) 456-7890",
      phoneNumber: titles?.emergency_service_default,
      isDefaultPhone: true,
    });
    formattedList?.forEach((item) => {
      const isBefore = item?.otherData?.call_before_911;
      if (!isBefore) {
        newList?.push(item);
      }
    });
    setEmergencyContactList(newList);
  };

  const regionList = (is_visible = true, is_for_mau = false) => {
    getRegionList({
      dispatch,
      userType: userData?.isGuestUser ? "guestuser" : "accountowner",
      is_visible: is_visible,
      is_for_mau: is_for_mau
    });
  };

  const onEditSubscriberDetail = () => {
    regionList(false, true);
    history?.push(ROUTES_CONSTANTS?.editSubscriberDetails, {
      medicalUserDetail,
      phoneTypeList,
    });
  };


  const protected_address = medicalUserDetail?.protected_address;

  const handleEmergencyInfoModal = () => {
    setShowEmergencyInfoModal(true);
  };

  const handleEditSubscriberDetail = () => {
    onEditSubscriberDetail();
  };

  // Card Header Component
  const CardHeader = ({ title, icon: IconComponent }) => (
    <>
      <div className="sp_card_header">
        <h3 className="sp_card_title">{title}</h3>
        <div className="sp_card_icon">
          <IconComponent />
        </div>
      </div>
      <div className="sp_separator"></div>
    </>
  );

  // Shipping Address Component
  const ShippingAddressInfo = ({ shippingAddress }) => (
    <div className="sp_shipping_info">
      <p className="sp_shipping_address_text">
        {getSubscriberProtectedAddress(shippingAddress)}
      </p>
    </div>
  );

  // Shipping Address Button Component
  const ShippingAddressButton = () => (
    <CustomButton
      text={titles?.edit}
      width="100%"
      onClick={() =>
        history.push(ROUTES_CONSTANTS?.shippingDetails, {
          medicalUserDetail: medicalUserDetail,
        })
      }
    />
  );

  // Emergency Plan Info Component
  const EmergencyPlanInfo = ({ emergencyContactList }) => (
    <div className="sp_emergency_contacts">
      {emergencyContactList?.map((item, index) => {
        if (item?.isDefaultPhone) {
          return (
            <div
              key={`emergency_phone ${index}`}
              className="sp_emergency_contact"
            >
              <div className="sp_contact_info">
                <span className="sp_contact_name">
                  {item?.phoneNumber?.trim()}
                </span>
              </div>
              <span className="sp_contact_type">{item?.primary_phone_type?.phone_type}</span>
            </div>
          );
        }
        const contactName =
          item?.name?.trim() + ", " + item?.relation?.relation;
        const phoneNumber = formatPhoneNumber(item?.phone);
        const phoneType = item?.primary_phone_type?.phone_type;
        return (
          <div key={index} className="sp_emergency_contact">
            <div className="sp_contact_info">
              <span className="sp_contact_name">{contactName}</span>
              <span className="sp_contact_phone">{phoneNumber}</span>
            </div>
            <span className="sp_contact_type">{phoneType}</span>
          </div>
        );
      })}
    </div>
  );

  // Emergency Plan Button Component
  const EmergencyPlanButton = () => (
    <CustomButton
      text={userData?.isGuestUser ? titles?.see_plan : titles?.edit_plan}
      width="100%"
      onClick={() => {
        regionList(false);
        history.push(ROUTES_CONSTANTS?.emergencyPlan, {
          medicalUserDetail: medicalUserDetail,
          emergencyContactList: emergencyContactList,
          emergencyData,
          languages: languageList,
        })
      }
      }
    />
  );

  // Signal History Info Component
  const SignalHistoryInfo = ({ deviceSignalHistory }) => (
    <div className="sp_signal_info">
      {deviceSignalHistory?.length > 0 ? (
        <div className="sp_signal_status">
          <p className="sp_signal_text">
            Status as of{" "}
            {convertInRequiredTimeZone(
              deviceSignalHistory?.[0]?.date,
              selectedMedicalUser?.timezone,
              currentTimeZone
            )}{`\n`}
            {deviceSignalHistory?.[0]?.device_name}
            {deviceSignalHistory?.[0]?.signal
              ? ` - ${deviceSignalHistory?.[0]?.signal}`
              : ""}
          </p>
        </div>
      ) : null}
    </div>
  );

  // Signal History Button Component
  const SignalHistoryButton = () => (
    <CustomButton
      text={titles?.see_all}
      width="100%"
      onClick={() =>
        history.push(ROUTES_CONSTANTS?.deviceSignalHistory, {
          isAllSignalHistory: true,
        })
      }
    />
  );

  return (
    <MainLayout
      text={titles?.subscriber_hub}
      isBackHide={false}
      isSemiHeader={true}
      white={true}
      isLoading={loading}
      snackBarMessage={snackBarMessage}
    >
      <InformationModal
        show={showEmergencyInfoModal}
        setShow={setShowEmergencyInfoModal}
        infoText={titles?.emergency_info_tooltip}
      />
      {!loading ? (
        <div className="sp_container">
          {/* Subscriber Information Card */}
          <SubscriberInformationCard medicalUserDetail={medicalUserDetail} />

          {/* Devices & Tracking Card */}
          <DeviceTrackingCard medicalUserDetail={medicalUserDetail} />

          {/* Subscriber Details Card */}
          <SubscriberDetailsCard
            medicalUserDetail={medicalUserDetail}
            protected_address={protected_address}
            onEditSubscriberDetail={handleEditSubscriberDetail}
            onEmergencyInfoModal={handleEmergencyInfoModal}
          />
          {/* Emergency Plan Card */}
          {userData?.isGuestUser && emergencyContactList?.length <= 0 ? null : (
            <div className="sp_emergency_plan_card">
              <CardHeader title={titles?.emergency_plan} icon={EmergencyIcon} />
              <EmergencyPlanInfo emergencyContactList={emergencyContactList} />
              <EmergencyPlanButton />
            </div>
          )}
          {/* Signal History Card */}
          <div className="sp_signal_history_card">
            <CardHeader title={titles?.all_signal_history} icon={SignalHistoryIcon} />
            <SignalHistoryInfo deviceSignalHistory={deviceSignalHistory} />
            <SignalHistoryButton />
          </div>
          {!userData?.isGuestUser ? (
            <>
              {/* Billing Details Card */}
              <BillingDetailsCard
                medicalUserDetail={medicalUserDetail}
                bankDetails={bankDetails}
                cardDetails={cardDetails}
                cardList={cardList}
                accountTypes={accountTypes}
                allRegionList={allRegionList}
              />
              {/* Shipping Address Card */}
              <div className="sp_shipping_address_card">
                <CardHeader title={titles?.shipping_address} icon={ShippingIcon} />
                <ShippingAddressInfo shippingAddress={medicalUserDetail?.shipping_address} />
                <ShippingAddressButton />
              </div>
              {/* More Options Section */}
              <div className="sp_more_options_section">
                <h3 className="sp_more_options_title">More Options</h3>
                {accordianButtons?.map((data, index) => {
                  return (
                    <div
                      key={`accordian_btns-${index}`}
                      className="sp_more_option_card"
                      onClick={data?.onClick}
                    >
                      <span className="sp_option_text">{data?.name}</span>
                      <ArrowRight className="sp_option_arrow" />
                    </div>
                  );
                })}
              </div>
            </>
          ) : null}
        </div>
      ) : null}
    </MainLayout>
  );
};

export default SubscriberProfile;
